// extracted by mini-css-extract-plugin
module.exports = {"root":"AlertsList_root__3mMFE mb-5","list":"AlertsList_list__3OM66","button":"AlertsList_button__1n-l1 button-reset"};